import e, { forwardRef as k } from "react";
import { c as s, t as u } from "./useKeyDown-88662051.mjs";
import { u as p } from "./LinkContext-0c83848a.mjs";
const L = "link", x = "error", g = "no-href", a = {
  link: L,
  error: x,
  noHref: g
}, N = k(function({
  className: l,
  children: n,
  href: t,
  disabled: i,
  disableLinkTextStyle: c,
  ...r
}, f) {
  const m = p();
  if (!t)
    return /* @__PURE__ */ e.createElement(e.Fragment, null, n);
  const o = s(
    !c && [a.link, u.textsLink],
    l
  );
  return i ? /* @__PURE__ */ e.createElement("div", { className: s(a.noHref, o) }, n) : /* @__PURE__ */ e.createElement(
    m,
    {
      href: t,
      prefetch: !1,
      className: o,
      ...r,
      ref: f,
      rel: r.target === "_blank" ? "noopener" : void 0
    },
    n
  );
});
export {
  N as L
};
//# sourceMappingURL=Link-460da2fc.mjs.map
